import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function IconButton(theme: Theme): unknown {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {},
      },
    },
  };
}
